import { Link } from "react-router-dom";

type LogoProps = {
  linkTo?: string;
  className?: string;
};

export function Logo({ linkTo = "/", className = "" }: LogoProps) {
  const content = (
    <span className={`flex flex-col sm:flex-row sm:items-center gap-0 sm:gap-2 ${className}`}>
      <span className="font-display text-2xl font-semibold lowercase tracking-tight text-secondary">
        supercharge
      </span>
      <span className="font-display text-xs lowercase text-muted">plugins for claude code</span>
    </span>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="transition-opacity hover:opacity-80">
        {content}
      </Link>
    );
  }

  return content;
}
